import { Form, Button } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'

import { Comment } from '../dtos'
import { createNewComment, CreateNewCommentProps } from './Comment'
import {
    TributeComponentParams,
    RichTextEditor as FroalaEditor
} from '../../rich-text-editor'

import * as styles from './Editor.module.less'

export interface EditorContainerProps {
    hideEditEditor?: () => void
    hideReplyEditor?: () => void
    getTributeComponent?: any
    goToComment?: (id: string) => void
    initialValue: string
    parentConversation: { id: string }
    user: { id: string }
    comment: Comment
    onAddComment: (comment: Comment, callback?: () => void) => void
    onEditComment?: (comment: Comment, callback?: () => void) => void
    editorType: 'default' | 'reply' | 'edit'
    submitting:
        | boolean
        | {
              delay?: number
          }
    tributes?: Array<any>
}

export const EditorContainer: React.FC<EditorContainerProps> = (props) => {
    const {
        comment,
        editorType,
        getTributeComponent,
        goToComment,
        hideEditEditor,
        hideReplyEditor,
        initialValue,
        parentConversation,
        submitting,
        tributes,
        user
    } = props

    const [value, setValue] = useState<string>(
        editorType === 'edit' ? initialValue : ''
    )

    const clearEditor = (editorType: 'default' | 'reply' | 'edit') => {
        setValue('')
        if (editorType === 'reply') {
            // @ts-ignore
            hideReplyEditor()
        } else if (editorType === 'edit') {
            // @ts-ignore
            hideEditEditor()
        }
    }

    const onCreateNewComment = (content: string) => {
        setValue(content)
    }

    useEffect(() => {
        if (
            value !== '' &&
            (editorType === 'default' || editorType === 'reply')
        ) {
            // HERE we assign the parent comment
            const newCommentArgs: CreateNewCommentProps = {
                comments: [],
                content: value,
                // @ts-ignore
                parentComment:
                    editorType === 'default' ? undefined : { id: comment.id },
                parentConversation,
                user
            }

            const newComment = createNewComment(newCommentArgs)
            props.onAddComment(newComment)

            if (editorType === 'default') {
                goToComment && goToComment('#lastComment')
                clearEditor('default')
            } else if (editorType === 'reply') {
                clearEditor('reply')
            }
        }
    }, [value])

    const onReplyToComment = (content: string) => {
        setValue(content)
    }

    const onEditComment = (content: string) => {
        const editedComment: Comment = { ...comment }
        editedComment.content = content
        props.onEditComment &&
            props.onEditComment(editedComment, () => clearEditor('edit'))
        clearEditor('edit')
    }

    const defaultEditor = editorType === 'default' && (
        <Form>
            <Form.Item>
                <FroalaEditor
                    content={value}
                    getTributeComponent={getTributeComponent}
                    onSave={onCreateNewComment}
                    saveButtonTitle="Add comment"
                    tributes={tributes}
                />
            </Form.Item>
        </Form>
    )

    const replyEditor = editorType === 'reply' && (
        <Form className={styles.editorReply}>
            <Form.Item>
                <FroalaEditor
                    content={value}
                    getTributeComponent={getTributeComponent}
                    onCancel={hideReplyEditor}
                    onSave={onReplyToComment}
                    saveButtonTitle="Reply"
                    tributes={tributes}
                />
            </Form.Item>
        </Form>
    )

    const editExistingCommentEditor =
        editorType === 'edit' ? (
            <Form>
                <Form.Item>
                    <FroalaEditor
                        content={value}
                        getTributeComponent={getTributeComponent}
                        onCancel={hideEditEditor}
                        onSave={onEditComment}
                        saveButtonTitle="Save"
                        tributes={tributes}
                    />
                </Form.Item>
            </Form>
        ) : (
            <React.Fragment />
        )

    return defaultEditor || replyEditor || editExistingCommentEditor
}
